module.exports = __webpack_public_path__ + "img/ico-monitor.f5e8c4ac.svg";